import { toast as sonnerToast } from "sonner"

export type ToastType = 'success' | 'error' | 'info' | 'warning'

interface ToastOptions {
  duration?: number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const toast = {
  success: (message: string, options?: ToastOptions) => {
    return sonnerToast.success(message, {
      duration: options?.duration || 4000,
      action: options?.action,
    })
  },
  
  error: (message: string, options?: ToastOptions) => {
    return sonnerToast.error(message, {
      duration: options?.duration || 4000,
      action: options?.action,
    })
  },
  
  info: (message: string, options?: ToastOptions) => {
    return sonnerToast.info(message, {
      duration: options?.duration || 4000,
      action: options?.action,
    })
  },
  
  warning: (message: string, options?: ToastOptions) => {
    return sonnerToast.warning(message, {
      duration: options?.duration || 4000,
      action: options?.action,
    })
  },
}

// Legacy compatibility function
export const showToast = (message: string, type: ToastType = 'success') => {
  switch (type) {
    case 'success':
      return toast.success(message)
    case 'error':
      return toast.error(message)
    case 'info':
      return toast.info(message)
    case 'warning':
      return toast.warning(message)
    default:
      return toast.success(message)
  }
}